//GeneratorFlag:[NoChange]
import Tenant from './tenant';
import City from './city';
import TenantType from './tenant-type';
import TenantFilter from './tenant-filter';

export default {Tenant, City, TenantType, TenantFilter}
export{Tenant, City, TenantType, TenantFilter}